import { render, staticRenderFns } from "./BranchEdit.vue?vue&type=template&id=3c2c5307&scoped=true"
import script from "./BranchEdit.vue?vue&type=script&lang=js"
export * from "./BranchEdit.vue?vue&type=script&lang=js"
import style0 from "./BranchEdit.vue?vue&type=style&index=0&id=3c2c5307&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c5307",
  null
  
)

export default component.exports